import * as React from "react";
import { Box, Grid, Pagination, PaginationItem } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { GetCanceledOrders, GetDeliveredOrders, GetInProgressOrders } from "../../service/store.service";
import { ApiResultModel } from "../../../models/common.model";
import { HistoryListRequest, HistoryListResponse } from "../../models/store.model";
import DuringCard from "./duringCard";
import { PageInfoModel } from "../../../models/common.model";
import { PaginationInfo } from "../../../models/loan.model";
import EmptyList from "./emptyList";
import HistorySkeleton from "./historySkeleton";


export default function Orders({ serviceName, activeTab }: any) {
    const [data, setData] = React.useState<HistoryListResponse[]>([]);
    const ProgressOrders = () => {
        const historyList = new HistoryListRequest();
        historyList.pageNumber = currentPaginationInfo.pageNumber;
        historyList.pageSize = 5;
        getInProgressOrders.mutate(historyList);
    }
    const DeliveredOrders = () => {
        const historyList = new HistoryListRequest();
        historyList.pageNumber = currentPaginationInfo.pageNumber;
        historyList.pageSize = 5;
        getDeliveredOrders.mutate(historyList);
    }
    const CanceledOrders = () => {
        const historyList = new HistoryListRequest();
        historyList.pageNumber = currentPaginationInfo.pageNumber;
        historyList.pageSize = 5;
        getCanceledOrders.mutate(historyList);
    }

    React.useEffect(() => {
        if (serviceName === "GetInProgressOrders" && activeTab === 0)
            ProgressOrders()
        if (serviceName === "GetDeliveredOrders" && activeTab === 1)
            DeliveredOrders()
        if (serviceName === "GetCanceledOrders" && activeTab === 2)
            CanceledOrders()
    }, [activeTab])

    const getInProgressOrders = useMutation(GetInProgressOrders, {
        onSuccess: (result: ApiResultModel<HistoryListResponse[]>) => {
            if (result.data) {
                setPageInfo(result.pageInfo);
                setData(result.data);
            }
        },
    });
    const getDeliveredOrders = useMutation(GetDeliveredOrders, {
        onSuccess: (result: ApiResultModel<HistoryListResponse[]>) => {
            if (result.data) {
                setPageInfo(result.pageInfo);
                console.log(pageInfo)
                setData(result.data)
            }
        },
    });
    const getCanceledOrders = useMutation(GetCanceledOrders, {
        onSuccess: (result: ApiResultModel<HistoryListResponse[]>) => {
            if (result.data) {
                setPageInfo(result.pageInfo);
                setData(result.data)
            }
        },
    });


    const nextIcon = () => {
        return (
            <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
        );
    };
    const previusIcon = () => {
        return (
            <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
        );
    };
    const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
        (): PageInfoModel => {
            let pageInfoModel = new PageInfoModel();
            pageInfoModel.pageNumber = -1;
            pageInfoModel.pageSize = 3;
            pageInfoModel.total = 0;
            return pageInfoModel;
        }
    );

    const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
        (): PaginationInfo => {
            let paginationInfo = new PaginationInfo();
            paginationInfo.pageNumber = 1;
            return paginationInfo;
        }
    );

    const changePageNumber = (newPageNumber: number) => {
        const historyList = new HistoryListRequest();
        historyList.pageNumber = newPageNumber;
        historyList.pageSize = 5;
        if (activeTab === 0)
            getInProgressOrders.mutate(historyList);
        if (activeTab === 1)
            getDeliveredOrders.mutate(historyList);
        if (activeTab === 2)
            getCanceledOrders.mutate(historyList);

        currentPaginationInfo.pageNumber = newPageNumber;
        setCurrentPaginationInfo(currentPaginationInfo);
    };

    const handleChangePagination = (event: any, value: any) => {
        changePageNumber(value);
    };
    return (
        <Box
            sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}
            style={{ width: '100%', height: '100%' }}
        >
            {
                pageInfo.pageNumber !== -1 ?
                    data.length === 0 ?
                        <Grid style={{ height: '43vh', textAlign: 'center' }}>
                            <EmptyList image={"images/EmptyList.png"} />
                        </Grid>
                        :
                        data?.map((item: any, key: number) => (
                            <Grid className="duringCartBox" style={{ marginBottom: '30px', height: 'auto', paddingBottom: '11px' }}>
                                <DuringCard data={item} parent={serviceName} />
                            </Grid>
                        ))
                    : <HistorySkeleton />
            }
            {
                data.length !== 0 ?
                    <>
                        <Grid container>
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={4} >
                                <span
                                    style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                                >
                                    تعداد کل :
                                    <span style={{ color: "#01AF43" }}>{pageInfo?.total}</span> مورد
                                </span>
                            </Grid>
                            <Grid item xs={4}  >
                                <Pagination
                                    renderItem={(item) => (
                                        <PaginationItem
                                            components={{
                                                previous: previusIcon,
                                                next: nextIcon,
                                            }}
                                            {...item}
                                        />
                                    )}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center !important",
                                        direction: "ltr",
                                        margin: "5px",
                                        button: {
                                            color: "#25D1C9",
                                            fontSize: "14px !important",
                                            fontFamily: "iranSans",
                                        },
                                    }}
                                    count={
                                        pageInfo ? Math.ceil(pageInfo?.total / pageInfo?.pageSize) : 0
                                    }
                                    onChange={handleChangePagination}
                                    page={currentPaginationInfo.pageNumber}
                                />
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </> : ""
            }
        </Box>
    );
}


